import React, { Component } from "react";
import { Redirect, Link } from "react-router-dom";
import { Button, Container, Card, Alert } from "react-bootstrap";
import { FaShoppingBag, FaGavel, FaRedo, FaStar } from "react-icons/fa";

import { checkCookie, getCookie } from "../../Utils/Utils";
import Header from "../../Content/Header/Header";
import { EXCLUDE_LIST } from "../../../constants/Constants";

require("./MainPage.scss");

const MAIN_PAGE_NAVIGATION = {
  "/subscription": {
    title: "Subscription Giving",
    description: "Set up monthly donations to provide ongoing support for our ministry.",
    cta: "Make an Impact",
    icon: FaRedo,
    image: "/subscription.png",
    highlight: true,
  },
  "/auction": {
    title: "Silent Auction",
    description: "Bid on exclusive items while supporting a great cause.",
    cta: "View Auction",
    icon: FaGavel,
    image: "/silent-auction.png",
  },
  "/shop-online": {
    title: "Shop Online",
    description: "Browse our online store to support our ministry through your purchases.",
    cta: "Visit our Online Store",
    icon: FaShoppingBag,
    image: "/food.png",
  },
  "/resonate-exclusives": {
    title: "Resonate Exclusives",
    description: "Discover a tempting selection of food, snacks, drinks, and exclusive fundraising items waiting for you at Resonate.",
    cta: "Learn More",
    icon: FaStar,
    image: "/resonate-exclusives.png",
  },
};

class MainPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      includeInExcludeList: false,
    };
  }

  componentDidMount() {
    const emailId = getCookie("emailId");

    if (!checkCookie("emailId")) {
      this.setState({ redirect: true });
    } else if (EXCLUDE_LIST.includes(emailId)) {
      this.setState({ includeInExcludeList: true });
    }
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />;
    }

    const navItems = Object.entries(MAIN_PAGE_NAVIGATION);

    return (
      <div className="main-page-container">
        <Header />

        <section className="main-page-hero">
          <Container className="hero-content">
            <h1 className="hero-title">Be part of continuous transformation</h1>
            <p className="hero-text">
              Explore ways to support the ministry — shop, donate, bid, and participate in ongoing impact.
            </p>

            {this.state.includeInExcludeList && (
              <Alert variant="warning" className="hero-alert">
                Your account has limited access to this page.
              </Alert>
            )}
          </Container>
        </section>

        <Container className="main-page-content">
         

          <div className="navigation-grid">
            {navItems.map(([path, item]) => {
              

              return (
                <Card
                  className={`nav-card ${item.highlight ? "highlight" : ""}`}
                  key={path}
                >
                  <Card.Body className="nav-card-body">
                    <div className="nav-card-content">
                      <div className="nav-card-left">
                        <div className="nav-card-heading">
                         
                          <Card.Title className="nav-card-title">
                            {item.title}
                          </Card.Title>
                        </div>

                        <Card.Text className="nav-card-text">
                          {item.description}
                        </Card.Text>
                      </div>

                      <div className="nav-card-image-wrap">
                        <img
                          src={item.image}
                          alt={item.title}
                          className="nav-card-image"
                        />
                      </div>
                    </div>

                    <Button as={Link} to={path} className="nav-card-button">
                      {item.cta || "Open"}
                    </Button>
                  </Card.Body>
                </Card>
              );
            })}
          </div>
        </Container>
      </div>
    );
  }
}

export default MainPage;